<itl-wizard-page
  [pageTitleTransPath]="'attachment.label.title'"
  [pageIsValid]="true"
  (doneClicked)="done()"
  (cancelClicked)="cancel()"
  [isSinglePage]="true"
>
  <itl-selection
    [title]="'attachment.label.type' | translate"
    [placeholder]="'attachment.label.type_placeholder' | translate"
    [(ngModel)]="selectedType"
    [values]="attachmentTypeSelectionItems"
    icon="alberta-attachment"
    [required]="true"
    (change)="attachmentTypeSelected()"
  ></itl-selection>
  <div *ngIf="loading" class="loading">
    <itl-loading-indicator></itl-loading-indicator>
    {{ 'attachment.prescriptionRequest.loadingAttachments' | translate }}
  </div>

  <div *ngIf="attachments?.length && !loading">
    <itl-button (click)="selectAllAttachments(allAttachmentsSelected)"
      >{{ allAttachmentsSelected ? ( 'attachment.prescriptionRequest.removeAll' | translate ) : (
      'attachment.prescriptionRequest.selectAll' | translate ) }}</itl-button
    >
    <itl-listitem *ngFor="let attachment of attachments" [disabled]="attachment.loading">
      <itl-listitem-icon>
        <ion-checkbox [(ngModel)]="attachment.selected"></ion-checkbox>
      </itl-listitem-icon>
      <itl-listitem-header>
        <span class="bold">{{ 'components.attachment.fileName' | translate }}: </span>
        {{ attachment.filename }}
      </itl-listitem-header>
      <itl-listitem-bottom-subheader>
        <div *ngIf="hasTherapy(attachment)">
          <span class="bold">{{ 'components.attachment.therapy' | translate }}: </span>{{ getTherapyName(attachment) }}
        </div>
        <div>
          <span class="bold">{{ 'components.attachment.creator' | translate }}: </span>{{ attachment.metadata.createdBy
          | username | async }}
        </div>
        <div *ngIf="attachment?.metadata?.createdAt">
          <span class="bold">{{ 'components.attachment.date' | translate }}: </span>
          {{ attachment.metadata.createdAt | amLocal | amDateFormat: 'lll' }}
        </div>
        <div *ngIf="attachment.metadata?.additionalDescription" class="additionalDescription safeSpace">
          <span class="bold">{{ 'components.attachment.additionalDescription' | translate }}: </span>
          {{ attachment.metadata.additionalDescription }}
        </div>
      </itl-listitem-bottom-subheader>
      <itl-listitem-status
        ><itl-button (click)="previewAttachment(attachment)"
          ><ion-icon name="alberta-preview"></ion-icon>{{ 'attachment.prescriptionRequest.preview' | translate
          }}</itl-button
        ></itl-listitem-status
      >
    </itl-listitem>
  </div>
</itl-wizard-page>
